/**
 * Der Schalter „Vollzugriff" (Spec 25, Oberfläche C/D) — geteilt zwischen
 * `AccessInviteSheet` (`access-invite-full-access`) und `AccessPersonSheet`
 * (`access-person-full-access`): gleiche Beschriftung, gleiche Zweitzeile,
 * gleiche Sperrung für externe Personen.
 *
 * `role="checkbox"` als Knopf statt `<input type="checkbox">` — dieselbe
 * Bauform wie `PaymentReservations.tsx`, weil es im Bestand keinen anderen
 * Kontrollkästchen-Baustein gibt und ein natives Checkbox-Eingabefeld hier
 * eigene Tailwind-Klassen für Rahmen und Häkchen bräuchte, die schon existieren.
 * `min-h-(--tap-min)` löst „mindestens 44px unter 768px, 36px am Zeiger" ohne
 * eigene Media Query (`tokens.css` definiert die Variable bereits so).
 *
 * D2 (Entscheidung Lukas): Kein eigener Kennsatz hier — nur der Zustand des
 * Schalters selbst. Die Akzentfarbe des Kennsatzes „Vollzugriff" in der Liste
 * ist eine andere Stelle (`PersonBadges.tsx`).
 */

interface FullAccessCheckboxProps {
  readonly testId: string
  readonly checked: boolean
  readonly onChange: (checked: boolean) => void
  /** Extern kann nie Vollzugriff haben (DB-Check `app_users_external_no_full_access_ck`,
   * Spec 25, Fachregel 2) — der Client sperrt den Schalter, entscheidet aber
   * nichts, was der Server nicht auch entscheidet. */
  readonly disabled?: boolean
}

export function FullAccessCheckbox({ testId, checked, onChange, disabled = false }: FullAccessCheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      data-testid={testId}
      aria-checked={checked}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={() => {
        onChange(!checked)
      }}
      className={`rounded-card flex min-h-(--tap-min) w-full items-start gap-3 border px-3 py-2 text-left transition-colors duration-(--duration-fast) ease-(--ease-out) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${
        checked ? 'border-accent' : 'border-border hover:bg-bg'
      } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
    >
      <span
        aria-hidden="true"
        className={`mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-sm border ${
          checked ? 'bg-accent border-accent text-accent-on' : 'border-border'
        }`}
      >
        {checked && '✓'}
      </span>
      <span className="flex flex-col gap-0.5">
        <span className="text-body text-text">Vollzugriff</span>
        <span className="text-label text-muted">Sieht und verwaltet alle Objekte, auch künftige.</span>
      </span>
    </button>
  )
}
